import { AttributeFilter } from "./interfaces";

export const STYLE_PRICE_ATTRIBUTE_FILTER: AttributeFilter = {
  code: "#style_price",
  label: "Price",
  options: [
    {
      label: "Price",
      value: "0,400"
    }
  ]
};

export const CUSTOM_ATTRIBUTE_FILTERS = [STYLE_PRICE_ATTRIBUTE_FILTER.code];

export const ORDERED_ALLOWED_FILTERS: AttributeFilter[] = [
  {
    code: "style_type",
    label: "Style Type",
    options: []
  },
  STYLE_PRICE_ATTRIBUTE_FILTER,
  {
    code: "dress_length",
    label: "Length",
    options: []
  },
  {
    code: "neckline",
    label: "Neckline",
    options: []
  },
  {
    code: "sleeve",
    label: "Sleeve",
    options: []
  },
  {
    code: "body_shape",
    label: "Body Type",
    options: []
  },
  {
    code: "colour_group",
    label: "Colour",
    options: []
  },
  {
    code: "season",
    label: "Season",
    options: []
  },
  {
    code: "style_preference",
    label: "Style Preference",
    options: []
  },
  {
    code: "trends",
    label: "Trend",
    options: []
  },
  {
    code: "occasion",
    label: "Occasion",
    options: []
  },
  {
    code: "designer",
    label: "Designer",
    options: []
  },
  {
    code: "accessories",
    label: "Accessories",
    options: []
  },
  {
    code: "size",
    label: "Size",
    options: []
  }
];

export const CUSTOM_ATTRIBUTE_FILTER_OPTION_LABELS: { [optionValue: string]: string } = {
  OneSize: "One Size",
  "Black and White": "B&W",
  "Black and Gold": "B&G"
};
